import React from 'react';

interface LoadingPageProps {
  darkMode: boolean;
}

const LoadingPage: React.FC<LoadingPageProps> = ({ darkMode }) => {
  return (
    <div className={`flex flex-col items-center justify-center min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">
          level<span className="text-blue-500">crm</span>
        </h1>
        <div className="relative w-64 h-4 bg-gray-200 rounded-full overflow-hidden">
          <div className="absolute top-0 left-0 h-full bg-blue-500 animate-load-progress"></div>
        </div>
        <p className="mt-4 text-lg">Chargement en cours...</p>
      </div>
    </div>
  );
};

export default LoadingPage;